import { useDispatch } from "react-redux";
import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
} from "shared/constants/ActionTypes";
import jwtAxios, { setAuthToken } from "./index";
import { baseURLAuth } from "shared/constants/AppConst";
const JWTAuthContext = createContext();
const JWTAuthActionsContext = createContext();
export const useJWTAuth = () => useContext(JWTAuthContext);
export const useJWTAuthActions = () => useContext(JWTAuthActionsContext);
import { useLocation, useNavigate } from "react-router-dom";
//import Cookies from "universal-cookie";


const JWTAuthAuthProvider = ({ children }) => {
    //const [userCodeValue, setUserCodeValue] = useState("");
    // const cookies = new Cookies();
    //const [token, setToken] = useState(cookies.get("token"));
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const bgsm_jwt = params.get("bgsm_jwt");
    const [jwtAuthData, setJWTAuthData] = useState({
        user: null,
        isAuthenticated: false,
        isLoading: true,
    });
    const dispatch = useDispatch();
    // ROLE IS ADDED FOR PROFILE SWITCH CASE
    const getAuthUserProfile = () => {
        const token = localStorage.getItem("token");
        if (!token) {
            setJWTAuthData({
                user: undefined,
                isLoading: false,
                isAuthenticated: false,
            });
            localStorage.clear();
            return;
        }
        setAuthToken(token);
        jwtAxios
            .get(`${baseURLAuth}/ashramwasi-details`)
            .then((res) => {
                if (res.status === 200 && res.data.status === "OK") {
                    let resData = res.data;
                    setJWTAuthData({
                        user: { ...resData },
                        isLoading: false,
                        isAuthenticated: true,
                    });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Your account has been disabled. please contact admin!",
                    });
                    logout();
                    localStorage.clear();
                }
            })
            .catch(() =>
                setJWTAuthData({
                    user: undefined,
                    isLoading: false,
                    isAuthenticated: false,
                })
            );
    };
    useEffect(() => {
        getAuthUserProfile();
    }, []);

    const signInUser = async ({ userCode, password }) => {
        dispatch({ type: FETCH_START });
        try {
            const resAuth = await jwtAxios.post(
                `${baseURLAuth}/ashramvasi-authenticate`,
                {
                    userCode,
                    password,
                }
            );
            if (resAuth.status === 200 && resAuth.data.status === "OK") {
                const tokenData = resAuth.data?.data;
                // SETTING TOKEN TO AXIOS & LOCALSTORAGE
                setAuthToken(tokenData);
                // GET USER PROFILE
                getAuthUserProfile();
                dispatch({ type: FETCH_SUCCESS });
            } else {
                dispatch({
                    type: FETCH_ERROR,
                    payload: resAuth.data.message || "Something went wrong",
                });
            }
        } catch (error) {
            setJWTAuthData({
                ...jwtAuthData,
                isAuthenticated: false,
                isLoading: false,
            });
            dispatch({
                type: FETCH_ERROR,
                payload:
                    error?.response?.status === 401
                        ? "You are not a dhamwasi user."
                        : "Something went wrong" || "Something went wrong",
            });
        }
    };
    const switchProfile = async (role) => {
        dispatch({ type: FETCH_START });
        try {
            const resAuth = await jwtAxios.get(
                `${baseURLAuth}/ashramwasi-profile-switch?role=${role}`
            );
            if (resAuth.status === 200 && resAuth.data?.status === "OK") {
                const tokenData = resAuth.data?.data;
                // SETTING TOKEN TO AXIOS & LOCALSTORAGE
                setAuthToken(tokenData);
                window.location.replace("/dashboard");
                dispatch({ type: FETCH_SUCCESS });
            } else {
                dispatch({
                    type: FETCH_ERROR,
                    payload: "Something went wrong",
                });
            }
        } catch (error) {
            setJWTAuthData({
                ...jwtAuthData,
                isAuthenticated: false,
                isLoading: false,
            });
            dispatch({
                type: FETCH_ERROR,
                payload: error?.response?.data?.error || "Something went wrong",
            });
        }
    };

    // Sign in with OTP feature

    const SigninUserValidate = async (userCode) => {
        //setUserCodeValue(userCode);
        try {
            const resAuth = await jwtAxios.post(
                `${baseURLAuth}/generate-ashramwasi-otp`,
                null,
                {
                    params: {
                        userCode,
                    },
                }
            );
            if (resAuth.status === 200 && resAuth.data.status === "OK") {
                return resAuth.data;
            } else {
                dispatch({
                    type: FETCH_ERROR,
                    payload: resAuth.data.message || "Something went wrong",
                });
            }
        } catch (error) {
            dispatch({
                type: FETCH_ERROR,
                payload:
                    error?.response?.status === 401
                        ? "You are not a dhamwasi user."
                        : "Something went wrong" || "Something went wrong",
            });
        }
    };

    const SigninOtpValidate = async (userCode, otp) => {
        //setUserCodeValue(userCode);
        try {
            const resAuth = await jwtAxios.post(
                `${baseURLAuth}/validate-ashramwasi-otp`,
                {
                    userCode,
                    otp,
                }
            );
            if (resAuth.status === 200 && resAuth.data.status === "OK") {
                const tokenData = resAuth.data?.data;
                // SETTING TOKEN TO AXIOS & LOCALSTORAGE
                setAuthToken(tokenData);
                // GET USER PROFILE
                getAuthUserProfile();
                dispatch({ type: FETCH_SUCCESS });
            } else {
                dispatch({
                    type: FETCH_ERROR,
                    payload: resAuth.data.message || "Something went wrong",
                });
            }
        } catch (error) {
            dispatch({
                type: FETCH_ERROR,
                payload:
                    error?.response?.status === 401
                        ? "You are not a dhamwasi user."
                        : "Something went wrong" || "Something went wrong",
            });
        }
        // const res = await postRequest("auth/otp-validation", {
        //     userCode: username,
        //     otp,
        // });
        // if (res.status === 200) {
        //     const token = res.data.token;
        //     setToken(token);
        // } else {
        //     setAuthDetails({
        //         isLoading: false,
        //         user: null,
        //     });
        // }
        // return res;
    };

    // Sign in with OTP feature

    // const logout = async () => {
    //     try {
    //         await Promise.allSettled([
    //             jwtAxios.post(`${baseURLAuth}/logout`, {}),
    //             jwtAxios.get("https://lms.bgsm.org/logout"),
    //             jwtAxios.get("https://learn.bgsm.org/profile/" + userCodeValue + "/lp-logout")
    //           ]);
    //     } catch (err) {
    //         console.error("Error:", err);
    //     }
    //     finally {
    //       localStorage.clear();
    //       setAuthToken();
    //       setJWTAuthData({
    //         user: null,
    //         isLoading: false,
    //         isAuthenticated: false,
    //       });
    //     }
    //   };

    const logout = async () => {
        try {
            // API calls only
            await Promise.allSettled([
                jwtAxios.post(`${baseURLAuth}/logout`, {})
            ]);
            const currentURI = window.location.href;
            const path = new URL(currentURI).pathname.replaceAll('/', '__');
            window.open(
                `https://lms.bgsm.org/logout?redirectToDhamwasi=${path}`,
                '_self'
            );
        } catch (err) {
            console.error("Error:", err);
        } finally {
            localStorage.clear();
            setAuthToken();
            setJWTAuthData({
                user: null,
                isLoading: false,
                isAuthenticated: false,
            });
        }
    };


    // Handle bgsm_jwt from URL
    useEffect(() => {
        if (bgsm_jwt) {
            //setToken(bgsm_jwt);
            localStorage.setItem("token", bgsm_jwt);
            setAuthToken(bgsm_jwt);
            getAuthUserProfile();
            navigate("/dashboard");
        }
    }, [bgsm_jwt]);

    // Normal token check on load
    //console.log("token>>",token)
    // useEffect(() => {
    //     if (!token) {
    //         setAuthToken("");
    //         setJWTAuthData({
    //             isLoading: false,
    //             user: null,
    //         });
    //         // getHeaderMenu();
    //     } else {
    //         setAuthToken(token);
    //         getAuthUserProfile(token);

    //     }
    // }, [token]);
    return (
        <JWTAuthContext.Provider
            value={{
                ...jwtAuthData,
            }}
        >
            <JWTAuthActionsContext.Provider
                value={{
                    // signUpUser,
                    signInUser,
                    getAuthUserProfile,
                    switchProfile,
                    logout,
                    SigninUserValidate,
                    SigninOtpValidate,
                }}
            >
                {children}
            </JWTAuthActionsContext.Provider>
        </JWTAuthContext.Provider>
    );
};
export default JWTAuthAuthProvider;

JWTAuthAuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
